/**
 * Request a Demo form
 */
/* globals WEBROOT */
export default class DemoForm {
    constructor() {
        this.demoFormData = {};
        this.parsleyOptions = {
            classHandler: (el) => el.$element.closest('.form-group'),
        };
        this.thanksMessage = $('#demo-request-submitted');

        this.initListeners();

        $('form#request-demo-form').parsley(this.parsleyOptions);
    }

    initListeners() {
        $(document).on('submit', 'form#request-demo-form', (e) => {
            e.preventDefault();
            e.stopPropagation();
            // console.log('submit');
            const $form = $(e.currentTarget);
            $form.find('button[type="submit"]').attr('disabled', 'disabled');

            function getFormData(form) {
                const unindexedArray = form.serializeArray();
                const indexedArray = {};

                $.map(unindexedArray, (n) => {
                    indexedArray[n.name] = n.value;
                });

                return indexedArray;
            }

            this.demoFormData = getFormData($('#request-demo-form'));

            fetch(`${WEBROOT}/wp-json/cloroxpro/v1/contact/demo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'same-origin',
                },
                body: JSON.stringify(this.demoFormData),
            })
                .then((response) => response.json())
                .then((data) => {
                    window.formResponse = data;
                    if (data.status === 0) {
                        // console.log('submit success');
                        // Show thank you message
                        $('form#request-demo-form').hide();
                        this.thanksMessage.fadeIn(200);
                    } else {
                        // console.log('submit failed');
                        // console.log(data);
                        const errorKey = Object.keys(data.data.errors)[0];
                        const { errorMessage } = data.data.errors[errorKey];
                        $('.error-container').show().find('.error-message').text(errorMessage);
                        // reenable submit
                        $form.find('button[type="submit"]').removeAttr('disabled');
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    // console.log('submit failed');
                    // reenable submit
                    $form.find('button[type="submit"]').removeAttr('disabled');
                });

            return false;
        });
    }
}
